import {
  Grid3x3Icon,
  HouseIcon,
  LayoutDashboardIcon,
  LibraryBigIcon,
  ListVideoIcon,
  MessageCircleQuestionIcon,
  PlusIcon,
  SettingsIcon,
  UsersIcon,
  type LucideIcon,
} from "lucide-react";

import type { Role } from "@/api/types";

export interface NavItem {
  label: string;
  to: string;
  icon: LucideIcon;
  /** Active only on an exact URL match, not on child routes. */
  end?: boolean;
}

export const APP_HOME = "/app";

export const PRIMARY_NAV: readonly NavItem[] = [
  { label: "Home", to: APP_HOME, icon: HouseIcon, end: true },
  { label: "Courses", to: "/app/courses", icon: LibraryBigIcon, end: true },
];

/** Instructors only: learners across every course they teach. */
export const PEOPLE_NAV: NavItem = { label: "People", to: "/app/people", icon: UsersIcon };

export const SETTINGS_NAV: NavItem = { label: "Settings", to: "/app/settings", icon: SettingsIcon };

export const ROLE_LABELS: Record<Role, string> = { instructor: "Instructor", student: "Student" };

/** The role-specific way to add a course: instructors create one, students join with a code. */
export function courseAction(role: Role): NavItem {
  return role === "instructor"
    ? { label: "New course", to: "/app/courses?new=1", icon: PlusIcon }
    : { label: "Join a course", to: "/app/courses?join=1", icon: PlusIcon };
}

export function coursePath(courseId: number): string {
  return `/app/courses/${courseId}`;
}

export interface CourseSection {
  label: string;
  /** Path segment under /app/courses/:id ("" for the overview). */
  segment: string;
  icon: LucideIcon;
}

/** Instructor course workspace pages, in tab order (course tabs and the command palette). */
export const COURSE_SECTIONS: readonly CourseSection[] = [
  { label: "Overview", segment: "", icon: LayoutDashboardIcon },
  { label: "Content", segment: "assignments", icon: ListVideoIcon },
  { label: "Students", segment: "students", icon: UsersIcon },
  { label: "Gradebook", segment: "gradebook", icon: Grid3x3Icon },
  { label: "Questions", segment: "questions", icon: MessageCircleQuestionIcon },
  { label: "Settings", segment: "settings", icon: SettingsIcon },
];

export function courseSectionPath(courseId: number, section: CourseSection): string {
  return section.segment ? `${coursePath(courseId)}/${section.segment}` : coursePath(courseId);
}
